<template>
    <section>
        <div id="sessao_tipo_do_seguro">
            <div class="row" id="renovacao">
                <div class="col-xs-12">
                    <h3>
                        <icon name="repeat"></icon> Tipo do seguro
                        <form-help title="Tipo do seguro"
                            description="Se for o primeiro seguro selecione a opção Novo Negócio, caso contrário selecione a companhia do seu seguro vigente.">
                        </form-help>
                    </h3>
                </div>
            </div>

            <div class="row">
                <div class="col-xs-12">
                    <div class="form-group" :class="{ 'has-error': errors.has('renewalInsurers.name') }">
                        <label :for="renewalInsurers.id">{{ renewalInsurers.label }}</label>
                        <v-select :options="renewalInsurers.options" label="text" :filterable="true" :reduce="x => x.id"
                            :name="renewalInsurers.name" :id="renewalInsurers.id"
                            :placeholder="renewalInsurers.placeholder" v-model="renewal.insurer" class="auto-select">
                            <span slot="no-options">Digite 3 ou mais caracteres para buscar</span>
                        </v-select>
                        <div class="error-message" v-if="errors.has(renewalInsurers.name)">{{
                                errors.first(renewalInsurers.name)
                        }}</div>
                    </div>
                </div>
            </div>

            <div ref="hasRenovation">
                <div class="row renovacao">
                    <div class="col-xs-12 col-md-4">
                        <div class="form-group" :class="{ 'has-error': errors.has('data.renewal.bonus_last') }">
                            <label for="data.renewal.bonus_last">Classe de bônus Anterior</label>
                            <form-help title="Classe de bônus anterior"
                                description="Deve-se informar a classe de bônus do contrato anterior.<br>Seguradoras que utilizam esse campo:<li>SulAmerica</li><li>Bradesco</li><li>Generali</li>">
                            </form-help>
                            <select class="form-control" id="data.renewal.bonus_last" name="data.renewal.bonus_last"
                                v-model="renewal.bonus_last"
                                v-validate="{ rules: { required: (renewal.insurer != 'new') } }"
                                data-vv-as="Bônus Anterior">
                                <option value=""> - Selecione - </option>
                                <option v-for="item in currentBonusClassOptions" :value="item" :key="item">{{ item }}
                                </option>
                            </select>
                            <div class="error-message" v-if="errors.has('data.renewal.bonus_last')">{{
                                    errors.first('data.renewal.bonus_last')
                            }}</div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-md-4">
                        <div class="form-group" :class="{ 'has-error': errors.has('data.renewal.bonus_current') }">
                            <label for="data.renewal.bonus_current">Classe de bônus Futura</label>
                            <form-help title="Classe de bônus a ser calculada"
                                description="Deve-se informar a classe de bônus que será calculada na nova vigência. Por exemplo: Se a classe de bônus vigente é 2, então você irá informar neste campo o valor 3.">
                            </form-help>
                            <select class="form-control" id="data.renewal.bonus_current"
                                name="data.renewal.bonus_current" v-model="renewal.bonus_current"
                                v-validate="{ rules: { required: (renewal.insurer != 'new') } }"
                                data-vv-as="Bônus Futuro">
                                <option value=""> - Selecione - </option>
                                <option v-for="item in currentBonusClassOptions" :value="item" :key="item">{{ item }}
                                </option>
                            </select>
                            <div class="error-message" v-if="errors.has('data.renewal.bonus_current')">{{
                                    errors.first('data.renewal.bonus_current')
                            }}</div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-md-4">
                        <div class="form-group" :class="{ 'has-error': errors.has('data.renewal.claim_amount') }">
                            <label class="lb-rd-esq" for="data.renewal.claim_amount">Quantidade de Sinistros <span
                                    class="text-danger">*</span></label>
                            <input type="number" class="form-control" id="data.renewal.claim_amount"
                                name="data.renewal.claim_amount" min="0" data-vv-as="Quantidade de Sinistros"
                                v-validate="{ rules: { required: (renewal.insurer != 'new'), numeric: true } }"
                                v-model="renewal.claim_amount">
                            <div class="error-message" v-if="errors.has('data.renewal.claim_amount')">{{
                                    errors.first('data.renewal.claim_amount')
                            }}</div>
                        </div>
                    </div>

                    <div class="col-xs-12 col-md-4">
                        <div class="form-group" :class="{ 'has-error': errors.has('data.renewal.prior_policy_end') }">
                            <label for="data.renewal.prior_policy_end">Data Final da Apólice Vigente</label>
                            <input type="text" class="form-control" id="data.renewal.prior_policy_end"
                                name="data.renewal.final_apolice" v-mask="'##/##/####'"
                                data-vv-as="Data Final da Apólice Vigente" v-model="renewal.prior_policy_end" />
                            <div class="error-message" v-if="errors.has('data.renewal.prior_policy_end')">{{
                                    errors.first('data.renewal.prior_policy_end')
                            }}</div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-md-4">
                        <div class="form-group" :class="{ 'has-error': errors.has('data.renewal.prior_policy') }">
                            <label for="data.renewal.prior_policy">Número da Apólice Vigente</label>
                            <input type="text" class="form-control" id="data.renewal.prior_policy"
                                name="data.renewal.prior_policy" v-model="renewal.prior_policy" />
                            <div class="error-message" v-if="errors.has('data.renewal.prior_policy')">{{
                                    errors.first('data.renewal.prior_policy')
                            }}</div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-md-4">
                        <div class="form-group" :class="{ 'has-error': errors.has('data.renewal.prior_ic') }">
                            <label for="data.renewal.prior_ic">C.I Vigente</label>
                            <input type="text" class="form-control" id="data.renewal.prior_ic"
                                name="data.renewal.prior_ic" v-model="renewal.prior_ic" />
                            <div class="error-message" v-if="errors.has('data.renewal.prior_ic')">{{
                                    errors.first('data.renewal.prior_ic')
                            }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import _ from 'lodash'
import jQuery from 'jquery'
import FormHelp from 'shared/modules/Help/FormHelp.vue'
import Select2 from 'shared/modules/Select2/Select2.vue'
import axios from 'axios'

export default {
    components: {
        FormHelp,
        Select2
    },
    props: { renewal: Object },
    data() {
        return {
            insurers: [],
            currentBonusClassOptions: [...Array(11).keys()],
            renewalInsurers: {
                id: 'cotacao_renovacao',
                name: 'data[renewal][insurer]',
                label: 'Seguradora atual',
                disabled: true,
                placeholder: 'Carregando...',
                options: [
                ]
            }
        }
    },
    computed: {
        orderedInsurers() {
            return _.orderBy(this.insurers, 'text')
        },
        quotation() {
            return this.$store.getters['quotation']
        }
    },
    created() {
        this.$root.$options.eventBus.$on("onAuthorizedToken", () =>
        {
            this.initRenewalList()   
        });
    },
    mounted() {
        
        jQuery(this.$refs.hasRenovation).hide()

    },
    watch: {
        orderedInsurers(value) {
            this.renewalInsurers.options = this.renewalInsurers.options.concat(value)
            this.renewalInsurers.disabled = false

        },
        'renewal.insurer': function (value) {           
            this.$store.commit('addNewSelect', {
                name: 'data[renewal][insurer]',
                value: value
            })
            let hasRenovation = jQuery(this.$refs.hasRenovation)
            if (value == null || value == 'new') {
                this.renewal.insurer = 'new'
                hasRenovation.slideUp('slow')
                this.renewal.bonus_last = ''
                this.renewal.bonus_current = ''
                this.renewal.claim_amount = '0'
                this.renewal.prior_policy_end = ''
                this.renewal.prior_policy = ''
                this.renewal.prior_ic = ''

                return
            }
            hasRenovation.slideDown('slow')
        },
        quotation(quotation) {
            if (!quotation.data.data.renewal)
                return

            this.renewal.insurer = quotation.data.data.renewal.insurer || 'new'
            this.renewal.bonus_last = quotation.data.data.renewal.bonus_last || null
            this.renewal.bonus_current = quotation.data.data.renewal.bonus_current || null
            this.renewal.claim_amount = quotation.data.data.renewal.claim_amount || 0
            this.renewal.prior_policy_end = quotation.data.data.renewal.prior_policy_end || 0
            this.renewal.prior_policy = quotation.data.data.renewal.prior_policy || ''
            this.renewal.prior_ic = quotation.data.data.renewal.prior_ic || ''
        }
    },
    methods: {
        initRenewalList() {
            axios.post(this.$root.$options.config.environment.applicationUrlApiAutomation + `/api/${this.$root.$options.config.insureLine}/version/1.0/renewal-list`,
                {
                    config: {
                        token: this.$root.$options.config.token
                    }
                }, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${this.$store.state.automationBearer}`
                }
            }
            ).then(response => {
                this.insurers = response.data.data
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// FormPartialRenovation.vue?ed1e6764